import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { Link, useParams } from 'react-router-dom';

import { obtenirDeploiementParId } from '../deploiements/deploiementApi';

function objetVersLignes(objet) {
  if (!objet || typeof objet !== 'object') {
    return <Typography variant="body2">Aucune donnee.</Typography>;
  }
  return Object.keys(objet).map((cle) => (
    <Typography key={cle} variant="body2" style={{ marginTop: 6 }}>
      <strong>{cle}:</strong> {String(objet[cle])}
    </Typography>
  ));
}

function SitewebReportDetails() {
  const { id } = useParams();
  const [rapport, setRapport] = useState(null);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState('');
  const isMobile = window.innerHeight > window.innerWidth;

  useEffect(() => {
    let actif = true;
    setChargement(true);
    setErreur('');
    obtenirDeploiementParId(id)
      .then((data) => {
        if (!actif) return;
        if (data && data.type && data.type !== 'deploiement_siteweb') {
          setErreur("Ce rapport n'est pas un deploiement siteweb.");
          return;
        }
        setRapport(data);
      })
      .catch((err) => {
        if (!actif) return;
        setErreur(err.message || 'Impossible de charger le rapport siteweb.');
      })
      .finally(() => { if (actif) setChargement(false); });
    return () => { actif = false; };
  }, [id]);

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Button component={Link} to="/Ingenierie/DeploiementsSiteweb" variant="outlined">Retour a la liste</Button>
        </Grid>
        <Grid item xs={12}>
          <Paper style={{ padding: 16 }}>
            <Typography variant="h5">Detail du rapport siteweb</Typography>
            <Typography variant="body2" color="textSecondary">Identifiant: {id}</Typography>
            <Divider style={{ marginTop: 12, marginBottom: 12 }} />

            {chargement && <CircularProgress size={24} />}
            {erreur && <Typography color="error">{erreur}</Typography>}

            {!chargement && !erreur && rapport && (
              <div>
                <Typography variant="subtitle1">Informations generales</Typography>
                {objetVersLignes({
                  dateRapport: rapport.dateRapport || rapport.createdAt || '-',
                  environnementCible: rapport.environnementCible || '-',
                  operateur: rapport.operateur || '-',
                  decisionFinale: rapport.decisionFinale || '-',
                })}
                <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                <Typography variant="subtitle1">Avant deploiement</Typography>
                {objetVersLignes(rapport.validationsPreDeploiement || {})}
                <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                <Typography variant="subtitle1">Pendant deploiement</Typography>
                {objetVersLignes(rapport.executionDeploiement || {})}
                <Divider style={{ marginTop: 12, marginBottom: 12 }} />
                <Typography variant="subtitle1">Apres deploiement</Typography>
                {objetVersLignes(rapport.validationsPostDeploiement || {})}
              </div>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default SitewebReportDetails;




// WEBPACK FOOTER //
// src/components/deploiementsSiteweb/SitewebReportDetails.js